export default "__VITE_ASSET__CkZ6_ydC__"